<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- GENERAL -->
    <vs-tab
      icon-pack="feather"
      icon="icon-user"
      :label="!isSmallerScreen ? 'General' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-home"
      :label="!isSmallerScreen ? 'Store' : ''"
      v-if="userAuth.company"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-company />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-box"
      :label="!isSmallerScreen ? 'Courier' : ''"
      v-if="userAuth.company"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-courier />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-lock"
      :label="!isSmallerScreen ? 'Change Password' : ''"
    >
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserSettingsGeneral from './ProfileGeneral'
import UserSettingsChangePassword from './ProfilePassword'
import UserSettingsCompany from './ProfileCompany'
import UserSettingsCourier from './ProfileCourier'
import axios from '../../../axios'
import router from '../../../router'

export default {
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    UserSettingsCompany,
    UserSettingsCourier,



  },
  data() {
    return {
      userAuth: this.$store.state.user

    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  method: {
    notAdmin() {
      return this.userAuth.company ? true : false
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
